import { Prefactura } from '../../models/Entities/Turnero';
import { CommonState } from '../common/state/commonState';

export interface TurneroPrefacturadorState extends CommonState<Prefactura> {
    current: Prefactura | undefined;
    porEstado: Prefactura[];

    isLoadingPorEstado: boolean;
    successLoadingPorEstado: boolean | undefined;
    failOnLoadingPorEstado: boolean;

    isUpdatingEstado: boolean;
    successUpdatingEstado: boolean | undefined;
    failOnUpdatingEstado: boolean;
}

export const TurneroPrefacturadorUnloadState: any = {
    // loading all
    isLoadingAll: false,
    isLoadingAllSuccess: undefined,
    FailGettingAll: false,

    // updating all
    isUpdatingAll: false,
    isUpdatingAllSuccess: undefined,
    FailUpdatingAll: false,

    // loading one
    isLoadingOne: false,
    isLoadingOneSuccess: undefined,
    FailGettingOne: false,

    // updating
    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,
    
    // adding
    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    // deleting
    isDeletingOne: false,
    isDeletingOneSuccess: undefined,
    FailDeletingOne: false,

    // list and error
    list: [],
    error: undefined,

    // custom
    current: undefined,
    porEstado: [],

    isLoadingPorEstado: false,
    successLoadingPorEstado: undefined,
    failOnLoadingPorEstado: false,

    isUpdatingEstado: false,
    successUpdatingEstado: undefined,
    failOnUpdatingEstado: false
};
